<template>
  <div>
    <div class="vue-utility-type-admin-wrap">
      <b-spinner v-if="!utilityTypes || !utilityTypes.length" class="spinner"></b-spinner>
      <div
      class="add-new-button-container"
      v-if="!createUtilityTypeFormVisible">
        <span
        class="add-new-button"
        @click="showCreateUtilityTypeForm">+</span><span class="add-new-button-label">Add new utility type</span>
      </div>
      <div v-if="utilityTypes && !createUtilityTypeFormVisible">
        <header v-if="!selectedUtilityType && !createUtilityTypeFormVisible">Edit utility type</header>
        <select-utility-type-dropdown
        v-if="utilityTypes"
        :utilityTypes="utilityTypes"
        :utilityTypeSelected="onUtilityTypeSelected"></select-utility-type-dropdown>
      </div>
      <div>
        <div>
          <create-utility-type-form
          v-if="createUtilityTypeFormVisible"
          :getAllUtilityTypes="getAllUtilityTypes"
          :hide="hideCreateUtilityTypeForm"
          :createUtilityTypeSuccess="onCreateUtilityTypeSuccess"></create-utility-type-form>
        </div>
        <template v-if="utilityTypeCreateSuccessMessage">
          <div
          class="utility-create-success-message"
          v-bind:class="{fade: utilityTypeCreateSuccessMessageFade}">&#10003;&nbsp;{{utilityTypeCreateSuccessMessage}}</div>
        </template>
        <edit-utility-type-form
        v-if="selectedUtilityType"
        :utilityTypes="utilityTypes"
        :selectedUtilityType="selectedUtilityType"
        :getAllUtilityTypes="getAllUtilityTypes"
        :destroySelectedUtilityType="destroySelectedUtilityType"
        :hide="hideEditUtilityTypeForm"
        :utilityTypeUpdateSuccess="onUtilityTypeUpdateSuccess"
        :onUtilityTypeRemoveSuccess="onUtilityTypeRemoveSuccess"></edit-utility-type-form>
      </div>
      <template v-if="utilityTypeUpdateSuccessMessage">
        <div
        class="utility-update-success-message"
        v-bind:class="{fade: utilityTypeUpdateSuccessMessageFade}">&#10003;&nbsp;{{utilityTypeUpdateSuccessMessage}}</div>
      </template>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import CreateUtilityTypeForm from "./CreateUtilityTypeForm";
import EditUtilityTypeForm from "./edit-utility-type/EditUtilityTypeForm";
import SelectUtilityTypeDropdown from "./edit-utility-type/SelectUtilityTypeDropdown";

export default {
  name: 'UtilityTypeAdminForm',
  components: {
    CreateUtilityTypeForm,
    EditUtilityTypeForm,
    SelectUtilityTypeDropdown
  },
  data() {
    return {
      utilityTypes: undefined,
      selectedUtilityType: undefined,
      createUtilityTypeFormVisible: undefined,
      utilityTypeCreateSuccessMessage: undefined,
      utilityTypeCreateSuccessMessageFade: undefined,
      utilityTypeUpdateSuccessMessage: undefined,
      utilityTypeUpdateSuccessMessageFade: false
    }
  },
  async created() {
    this.getAllUtilityTypes();
  },
  methods: {
    showCreateUtilityTypeForm() {
      this.selectedUtilityType = undefined;
      this.createUtilityTypeFormVisible = true;
    },
    hideCreateUtilityTypeForm() {
      this.createUtilityTypeFormVisible = undefined;
    },
    hideEditUtilityTypeForm() {
      this.selectedUtilityType = undefined;
    },
    destroySelectedUtilityType() {
      this.selectedUtilityType = undefined;
      this.getAllUtilityTypes();
    },
    fadeOutUpdateSuccessMessage() {
      setTimeout(() => this.utilityTypeUpdateSuccessMessageFade = true, 3000);
      setTimeout(() => {
        this.utilityTypeUpdateSuccessMessage = undefined;
        this.utilityTypeUpdateSuccessMessageFade = false
      }, 5000);
    },
    onUtilityTypeSelected(utilityType) {
      if (!utilityType){
        this.selectedUtilityType = undefined;
        return;
      }

      this.selectedUtilityType = JSON.parse(JSON.stringify(utilityType));
      this.$forceUpdate();
    },
    onUtilityTypeRemoveSuccess(utility) {
      this.hideEditUtilityTypeForm();
      this.utilityTypeUpdateSuccessMessage = `${utility.name} has been removed`;
      this.getAllUtilityTypes();
      this.fadeOutUpdateSuccessMessage();
    },
    onCreateUtilityTypeSuccess(utilityType) {
      this.hideCreateUtilityTypeForm();
      this.getAllUtilityTypes();
      this.utilityTypeCreateSuccessMessage = `${utilityType.name} created`;
      setTimeout(() => this.utilityTypeCreateSuccessMessageFade = true, 3000);
      setTimeout(() => {
        this.utilityTypeCreateSuccessMessage = undefined;
        this.utilityTypeCreateSuccessMessageFade = false
      }, 5000);
    },
    onUtilityTypeUpdateSuccess(utilityType) {
      this.getAllUtilityTypes();
      this.utilityTypeUpdateSuccessMessage = `${utilityType.name} has been updated`;
      this.fadeOutUpdateSuccessMessage();
    },
    async getAllUtilityTypes() {
      this.utilityTypes = undefined;
      try {
        API.GetUtilityTypes().then(utilityTypes => {
          this.utilityTypes = utilityTypes || undefined;
          this.$forceUpdate();
        });
      } catch (err) {
        console.log("Unable to fetch utility types");
        console.log(err);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/partials/_variables.scss";

.vue-utility-type-admin-wrap{
  position: relative;
  min-height: 70px;

  .create-utility-button-wrap{
    position: absolute;
    top: 0;
    right: 0;
  }

  header{
    margin: 20px 0 20px 5px;
    font-weight: $bold;
    color: $black;
  }

  .utility-create-success-message,
  .utility-update-success-message{
    margin-top: 20px;
    font-weight: bold;
    color: green;
    transition: all 3s ease;

    &.fade{
      opacity: 0;
    }
  }
}
</style>





